<script lang="ts" setup>
	import {computed} from 'vue';

	const props = defineProps<{
		name?: string;
		alternateText?: string;
		type: string;
		extension: string;
	}>();

	const iconPath = computed(() => {
		const {name, type, extension} = props;
		return `/assets/images/build/icons-catalog/${type}/${name}.${extension}`;
	});
</script>

<template>
	<div v-if="name">
		<img :alt="alternateText" :src="iconPath" />
	</div>
</template>
